export default __webpack_public_path__ + "static/media/tour-6.d9fbd0e4.png";